export default [
    {
        name: 'Airline',
        value: 's_airline'
    },
    {
        name: 'Flight Number',
        value: 's_flight_number'
    },
    {
        name: 'Date',
        value: 'd_flight',
        date: true,
        utc: true
    },
    {
        name: 'Validated',
        value: 'b_validated',
        boolean: true
    },
    {
        name: 'Created Date',
        value: 't_created',
        datetime: true,
        utc: true
    },
];